import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/service/auth.service';
import { Localization } from '../../Localization';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  user: string;

  constructor(
    public readonly localization: Localization,
    private router: Router,
    private authenticationService: AuthService
  ) {}

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(
      (currentUser) =>
        (this.user =
          currentUser != null ? currentUser.usuario.chrUserName : null)
    );
  }

  closeLogout(): void {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
    localStorage.removeItem('User');
    localStorage.clear();
  }

  onReturn(): void {
    this.router.navigate(['/']);
  }
}
